import { Component, ViewChild } from '@angular/core';
import { EaDisplay } from '@app/components/pr-display';
import { PrNotificationService } from '../pr-notification.service';
import { PrNotificationComponent } from '../pr-notification/pr-notification.component';
import { PrNotificationHostDirective } from './pr-notification-host.directive';

@Component({
    selector: 'pr-notification-container',
    templateUrl: './pr-notification-container.component.html',
    styleUrls: ['./pr-notification-container.component.scss'],
    standalone: false
})
export class PrNotificationContainerComponent {
  @ViewChild(PrNotificationHostDirective, { static: true })
  container!: PrNotificationHostDirective;

  constructor(private service: PrNotificationService) {
    this.service.container = this;
  }

  notify(
    display: EaDisplay,
    title: string,
    description: string,
    timeout: number = 3000,
  ) {
    this.createComponent(display, title, description, timeout);
  }

  createComponent(
    display: EaDisplay,
    title: string,
    description: string,
    timeout?: number,
  ) {
    const componentRef = this.container.viewContainerRef.createComponent(
      PrNotificationComponent,
    );
    componentRef.instance.display = display;
    componentRef.instance.title = title;
    componentRef.instance.description = description;

    setTimeout(() => {
      componentRef.instance.close();
      setTimeout(() => {
        this.container.viewContainerRef.remove(
          this.container.viewContainerRef.indexOf(componentRef as any),
        );
      }, 1100);
    }, timeout);
  }
}
